/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useContext } from 'react';
import { Accordion, Card, useAccordionToggle } from 'react-bootstrap';
import AccordionContext from 'react-bootstrap/AccordionContext';
import classNames from 'classnames';
import { PageComponent } from '@root/pages/Type';
import { Trans } from 'react-i18next';
import styles from './FaqSection.module.scss';
import { FaqData } from './Index.page';
import { default as CaretDown } from '@static/img/icons/caret-down.svg';
import { default as CaretUp } from '@static/img/icons/caret-up.svg';

function SmartAccordionToggle({ children, eventKey }) {
    const currentEventKey = useContext(AccordionContext);
    const isCurrentEventKey = currentEventKey === eventKey;
    const decoratedOnClick = useAccordionToggle(eventKey);
    return (
        <h5
            className={classNames({ [styles.active]: isCurrentEventKey })}
            onClick={(event) => {
                if (isCurrentEventKey) {
                    event.preventDefault();
                    return;
                }
                decoratedOnClick(event);
            }}
        >
            <span>{children}</span>
            {isCurrentEventKey ? <CaretDown /> : <CaretUp />}
        </h5>
    );
}
type FaqSectionProps = {
    data: FaqData[];
};

const FaqSection: PageComponent<FaqSectionProps> = ({ data }) => {
    // TODO: make translated FAQ
    return (
        <section className={`container ${styles.section}`}>
            <h1 className={styles.title}>
                <Trans i18nKey="faqSection.title" ns="landingHelpFaq">
                    D.U.K.
                </Trans>
            </h1>
            <p className={styles.desc}>
                <Trans i18nKey="faqSection.description" ns="landingHelpFaq">
                    Dažniausiai užduodami klausymai
                </Trans>
            </p>

            <div className="row">
                <div className="col-lg-8 m-auto">
                    <Accordion
                        defaultActiveKey={
                            data.length > 0 ? data[0].id.toString() : '0'
                        }
                        className={styles.accordion}
                    >
                        {data.map((faq) => (
                            // eslint-disable-next-line react/no-array-index-key
                            <Card className={styles.card} key={`faq-${faq.id}`}>
                                <Card.Header className={styles.card_header}>
                                    <SmartAccordionToggle
                                        eventKey={faq.id.toString()}
                                    >
                                        {faq.title_translate}
                                    </SmartAccordionToggle>
                                </Card.Header>
                                <Accordion.Collapse
                                    eventKey={faq.id.toString()}
                                >
                                    <Card.Body className={styles.card_body}>
                                        {faq.content_translate}
                                    </Card.Body>
                                </Accordion.Collapse>
                            </Card>
                        ))}
                    </Accordion>
                </div>
            </div>
        </section>
    );
};
export default FaqSection;
